import { useRef, useState } from 'react';
import classes from './ListTooltip.module.css'
import Card from '../../components/Card/Card';
import { AiOutlineInfoCircle } from 'react-icons/ai';

const ListTooltip = ({text, info, index, className, tooltipCard}) => {
    const [activeTooltip, setActiveTooltip] = useState(null);
    const [tooltipStyle, setTooltipStyle] = useState({});
  const listRef = useRef([]);

  const handleMouseEnter = (index) => {
    const itemElement = listRef.current[index];
    if (itemElement) {
      const rect = itemElement.getBoundingClientRect();
      const tooltipWidth = 450; // Tooltip width defined in CSS
      const isNearScreenEdge = rect.left + tooltipWidth > window.innerWidth;

      setTooltipStyle({
        top: rect.top - 10, // Position tooltip above the item
        left: isNearScreenEdge ? rect.left - (tooltipWidth - rect.width) : rect.left,
      });
      setActiveTooltip(index);
    }
  };

  const handleMouseLeave = () => {
    setActiveTooltip(null);
    setTooltipStyle({});
  };
    return(
        <div className={`${classes.wrapper} ${className} d-flex align-items-center gap-2`} ref={(el) => (listRef.current[index] = el)}
        onMouseEnter={() => handleMouseEnter(index)}
        onMouseLeave={handleMouseLeave} role='button'>{text}
            <AiOutlineInfoCircle color='#CECECE' size={14} />
        {activeTooltip === index && info && <Card className={`${classes.tooltipBox} ${tooltipCard}`} style={{ top: tooltipStyle.top, left: tooltipStyle.left }}>{info}</Card>}
        </div>
    )
}

export default ListTooltip